


































































import Vue from "vue";
import Component from "vue-class-component";
import Api from '../../base/api.typings';
import { Prop } from 'vue-property-decorator';
import pesquisaService from './pesquisa-service';
import routerService from '../../base/router-service';

@Component
export default class PesquisaResultado extends Vue {
	@Prop() pesquisa: string

	paginaTamanho: number = 10;

	paginaAtual: number = 1;

	resultado: Api.App.Server.Pesquisa.Pesquisar.ResultadoDto = null;

	TipoResultado = Api.Common.Domain.ResultadoTipoPesquisaEnum;

	async exibirResultadoPesquisa() {
		this.resultado = await pesquisaService.pesquisar({
			paginaAtual: this.paginaAtual,
			paginaTamanho: this.paginaTamanho,
			pesquisa: this.pesquisa
		});
	}

	async alterarPagina(incremento: number) {
		this.paginaAtual += incremento;

		if (this.paginaAtual <= 1)
			this.paginaAtual = 1;

		await this.exibirResultadoPesquisa();
	}

	async imprimirDocumento(event, documentoId: string) {
		(this.$refs.documentoVisualizar as any).imprimirDocumento(event, documentoId);
	}

	exibirDocumento(event, documentoId: string, documentoTitulo: string) {
		(this.$refs.documentoVisualizar as any).exibirDocumento(event, documentoId, documentoTitulo);
	}

	detalharChamado(chamadoId: number) {
		routerService.goTo('chamado-detalhar', { chamadoId });
	}

	carregarDados() {
		if (!this.pesquisa)
			routerService.goTo('home');

		this.exibirResultadoPesquisa();
	}

	async beforeRouteUpdate(to, from, next) {
		await next();

		this.carregarDados();
	}

	created() {
		this.carregarDados();
	}
}
